import { useEffect } from 'react';
import useUser from '@/hooks/useUser';
import { useBrazeWebEnv } from '../hooks';
import type { BrazeWebSDKType } from '../types';

type Initialize = (braze: BrazeWebSDKType | undefined) => void;
type Options = {
  apiKey: string;
  baseUrl: string;
  allowUserSuppliedJavascript: boolean;
};
type Props = { onInitialize: Initialize };

const brazeInitialize = async (
  onInitialize: Initialize,
  { apiKey, baseUrl, allowUserSuppliedJavascript }: Options
) => {
  // Cast to unknown then to BrazeWebSDKType, because import can't be recognised as the same type
  const webSDK = (await import('@braze/web-sdk')) as unknown as BrazeWebSDKType;

  if (webSDK.initialize(apiKey, { baseUrl, allowUserSuppliedJavascript })) {
    onInitialize(webSDK);
  }
};

const BrazeWebInitialize = ({ onInitialize }: Props) => {
  const { data: profile } = useUser();
  const { API_KEY: apiKey, SDK_ENDPOINT: baseUrl } = useBrazeWebEnv();

  useEffect(() => {
    if (profile?.loggedIn) {
      brazeInitialize(onInitialize, {
        apiKey,
        baseUrl,
        allowUserSuppliedJavascript: true,
      });
    }
  }, [profile, onInitialize, apiKey, baseUrl]);

  return null;
};

export default BrazeWebInitialize;
